import { render, staticRenderFns } from "./PopupViewTwo.vue?vue&type=template&id=18b60b8a&scoped=true&"
import script from "./PopupViewTwo.vue?vue&type=script&lang=js&"
export * from "./PopupViewTwo.vue?vue&type=script&lang=js&"
import style0 from "./PopupViewTwo.vue?vue&type=style&index=0&id=18b60b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b60b8a",
  null
  
)

export default component.exports